import React from "react";
import "./ErrorMessage.scss"

export interface ErrorMessageProps {
    text?: string;
}
 
export interface ErrorMessageState {
    
}
 
class ErrorMessage extends React.Component<ErrorMessageProps, ErrorMessageState> {
    constructor(props: ErrorMessageProps) {
        super(props);
        this.state = {  };
    }
    render() { 
        return ( 
            <div className="error-msg">
                <p>{this.props.text}</p>
            </div>
         );
    }
}
 
export default ErrorMessage;